module.exports = __webpack_public_path__ + "static/media/constellation-screen.9b3d076c.png";